export default {
  getData(state) {
    return state.data;
  },
  isFetching(state) {
    return state.isFetching;
  },
  getRequestStatus(state) {
    return state.requestStatus;
  },
};
